module.exports = __webpack_public_path__ + "static/how-to-survive-a-plague-f7d19c65af986e7864b1b599f455536b.jpg";